<div [style.visibility]="show?'visible':'hidden'" class="custom-popup pit-utility-cable-popup modal left fade">
  <div class="modal-dialog" (clickOutside)="hideSEGDetailFn($event)">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title card-title"><span class="d-block small-light-text">{{ 'SEG' | translate }}</span>
      {{selectedSEG?.segName}}</h4><button aria-label="Close" class="close"
      type="button" (click)="hideSEGDetailFn($event)"><span aria-hidden="true">&times;</span></button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12 col-lg-7 border-right">
          <app-exposure-in-location
            [loadingExposureDetail]="loadingExposureDetail" [showSegReport]="showSegReport"
            [exposureDetail]="exposureDetail">
          </app-exposure-in-location>
          <app-contribution-to-exposures
            [loading]="loading" [selectedSEG]="selectedSEG" [showRep]="show" (hideSEGDetailEmit)="hideSEGDetailFn($event)" [segTasks]="segTasks"
            [exposureContribution]="exposureContribution" [showSegReport]="showSegReport" (showSEGDetailEmit)="showSEGDetailFn($event)"
            (toggleTaskwithSEGPopupEmit)="toggleTaskwithSEGPopup($event)"
            (sortExposureContributionEmit)="sortExposureContribution($event)">
          </app-contribution-to-exposures>
        </div>
        @if (showSegReport) {
          <div class="col-md-12 col-lg-5">
            <app-control-history></app-control-history>
            <app-exposure-by-chart
              [taskRequestType]="taskRequestType"
            (toggleTaskRequestEmit)="toggleTaskRequest()"></app-exposure-by-chart>
          </div>
        }
      </div>
    </div>
  </div>
</div>
</div>

